export function normalizePath(pathname) {
  const clean = String(pathname || "").replace(/\/+$/, "");
  return clean || "/";
}
